import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ComponentChanges } from '@bcl/design-system';
import { Platform } from '@ionic/angular';
import { VoiceRecorder } from 'capacitor-voice-recorder';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'pc-chat-send-message',
  templateUrl: './chat-send-message.component.html',
  styleUrls: ['./chat-send-message.component.scss'],
})
export class ChatSendMessageComponent implements OnChanges, OnInit {
  @Input()
  public isSendingFileMessage = false;

  @Output()
  public textAccepted = new EventEmitter<string>();
  @Output()
  public fileSelected = new EventEmitter<File>();

  public readonly messageTextFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/\S/),
  ]);

  @ViewChild('uploadInput')
  private uploadInput!: ElementRef<HTMLInputElement>;

  constructor(public platform: Platform) {}

  public get isNotIOS(): boolean {
    return Capacitor.getPlatform() !== 'ios';
  }

  public async ngOnInit() {
    if (Capacitor.getPlatform() !== 'ios') {
      const { value } = await VoiceRecorder.requestAudioRecordingPermission();
    }
  }

  public ngOnChanges(
    changes: ComponentChanges<ChatSendMessageComponent>
  ): void {
    if (
      changes.isSendingFileMessage &&
      changes.isSendingFileMessage.currentValue === false
    ) {
      if (this.uploadInput?.nativeElement) {
        this.uploadInput.nativeElement.value = '';
      }
    }
  }

  public sendTextMessage(): void {
    if (this.messageTextFormControl.invalid) {
      return;
    }

    const textMessage = this.messageTextFormControl.value;

    if (textMessage) {
      this.textAccepted.next(textMessage);
      this.messageTextFormControl.reset();
    }
  }

  public onTextAreaKeydown($event: KeyboardEvent): void {
    if ($event.key === 'Enter' && $event.ctrlKey) {
      this.sendTextMessage();
    }
  }

  public onFilesSelected(files: FileList | null): void {
    if (!files?.length) {
      return;
    }
    const file = files[0];
    this.fileSelected.next(file);
  }

  public setMessageText(text: string): void {
    this.messageTextFormControl.setValue(text);
  }
}
